import React, { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';

const galleryImages = [
  {
    id: 1,
    src: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/yecmydoe_freepik__plano-macro-de-una-croqueta-frindose-en-aceite-de-__52053.png',
    alt: 'Croqueta cuadrada friéndose en aceite de oliva virgen extra',
    caption: 'Aceite de oliva. Temperatura precisa.',
    span: 'row-span-2',
  },
  {
    id: 2,
    src: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/vg7ddlad_freepik__emplatado-gourmet-de-croquetas-de-setas-sobre-una-__52056.png',
    alt: 'Emplatado gourmet de croquetas cuadradas sobre pizarra con microvegetales',
    caption: 'Presentación que lo dice todo.',
  },
  {
    id: 3,
    src: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/2shrpuwq_freepik__plano-cenital-de-una-mesa-elegante-con-amigos-cena__52055.png',
    alt: 'Mesa elegante con amigos compartiendo una bandeja de croquetas',
    caption: 'Para compartir. Siempre.',
  },
  {
    id: 4,
    src: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/if7yay1w_freepik__primersimo-primer-plano-de-una-croqueta-cuadrada-d__52063.png',
    alt: 'Primer plano del interior cremoso de una croqueta',
    caption: 'La bechamel que buscabas.',
  },
  {
    id: 5,
    src: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/2e8f70if_freepik__una-mano-sosteniendo-una-croqueta-cuadrada-gourmet__52066.png',
    alt: 'Mano sosteniendo una croqueta cuadrada con vistas al mar al atardecer',
    caption: 'El momento que merece.',
  },
];

const GaleriaSection = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <>
      <section
        id="galeria"
        data-testid="galeria-section"
        className="py-20 md:py-32 bg-[#2C2C2A]"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4A853] mb-3">
              En cada bocado
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl font-bold text-white">
              La Galería
            </h2>
            <p className="text-white/50 mt-4 max-w-md mx-auto text-sm">
              De la sartén a tu mesa. Cada detalle tiene un porqué.
            </p>
          </div>

          {/* Asymmetric Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {/* First image spans 2 rows on desktop */}
            <div
              className="relative md:row-span-2 overflow-hidden cursor-zoom-in group"
              onClick={() => setLightbox(galleryImages[0])}
              data-testid="gallery-img-1"
            >
              <div className="aspect-square md:aspect-auto md:h-full min-h-48">
                <img
                  src={galleryImages[0].src}
                  alt={galleryImages[0].alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-end p-4">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-2">
                  <ZoomIn size={16} className="text-white" />
                  <span className="text-white text-xs font-medium">
                    {galleryImages[0].caption}
                  </span>
                </div>
              </div>
            </div>

            {/* Remaining 4 images */}
            {galleryImages.slice(1).map((img) => (
              <div
                key={img.id}
                className="relative overflow-hidden cursor-zoom-in group aspect-square"
                onClick={() => setLightbox(img)}
                data-testid={`gallery-img-${img.id}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-end p-3">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-1.5">
                    <ZoomIn size={14} className="text-white" />
                    <span className="text-white text-xs">{img.caption}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA for more photos */}
          <div className="mt-10 text-center">
            <p className="text-white/40 text-sm">
              ¿Quieres ver más? Síguenos en Instagram para actualizaciones diarias.
            </p>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 bg-black/90 z-[60] flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
          data-testid="lightbox-overlay"
        >
          <button
            className="absolute top-5 right-5 text-white/70 hover:text-white transition-colors"
            onClick={() => setLightbox(null)}
            data-testid="lightbox-close"
          >
            <X size={28} />
          </button>
          <div className="max-w-4xl max-h-[90vh] w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={lightbox.src}
              alt={lightbox.alt}
              className="w-full h-full object-contain"
            />
            <p className="text-white/60 text-center text-sm mt-4 font-serif italic">
              {lightbox.caption}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default GaleriaSection;
